import { Injectable, OnDestroy } from '@angular/core';
import { TimeTracking } from 'server/shared/models/timeTracking';
import { SubscriptionService } from '../shared/subscription.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class TimeTrackingService implements OnDestroy {
  constructor(
    private userService: UserService,
    private subscriptionService: SubscriptionService,
  ) {}

  ngOnDestroy() {}

  saveTimeTracking(options: {
    jobId: string;
    timeTrackings: TimeTracking[];
    inviteeId: string;
    userId: string | null;
    externalLinkValidatorData?: {
      secret: string;
      name?: string;
      userAgent?: string;
      ip?: string;
    };
    callback: (error: Meteor.Error) => void;
  }) {
    Meteor.call(
      'updateTimeTracking',
      options.jobId,
      options.timeTrackings,
      options.inviteeId,
      options.userId,
      options.externalLinkValidatorData,
      options.callback,
    );
  }
}
